import * as Yup from "yup";
import { capitalizeWords } from "../../../../utils";

const FormAddUserValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Preencha o primeiro nome")
    .trim()
    .transform((firstName: string) => {
      return capitalizeWords(firstName);
    }),
  lastName: Yup.string()
    .required("Preencha o último nome")
    .trim()
    .transform((lastName: string) => {
      return capitalizeWords(lastName);
    }),

  email: Yup.string()
    .email("Digite um email válido")
    .lowercase()
    .trim()
    .required("Preencha o e-mail"),
  enabled: Yup.boolean().default(true),
  emailVerified: Yup.boolean().default(false),
  profile: Yup.string().required("Selecione um perfil"),
  attributes: Yup.object().shape({
    BPID: Yup.string()
    .when('$profile', {
      //TODO: Desabilitado temporariamente o profile === 'driver'
      is: (profile) => profile === 'carrier', //NOTE: BPID de Transportadora e motorista
      then: Yup.string()
        .required("Preencha o BP ID ")
        .trim()
        .transform((BPID: string) => {
          return capitalizeWords(BPID);
        }),
      otherwise: Yup.string().nullable(),
    }),
    INTERNAL_NAME: Yup.string()
      .when('profile', {
        is: (profile) => profile === 'CARRIER', // Transportadora
        then: Yup.string()
          .required("Preencha o INTERNAL_NAME ")
          .trim()
          .transform((INTERNAL_NAME: string) => {
            return capitalizeWords(INTERNAL_NAME);
          }),
        otherwise: Yup.string().nullable(), 
      }),
    CNPJ: Yup.array()
      .of(
        Yup.object().shape({
          CNPJ: Yup.string().required().trim(),
          companyName: Yup.string().uppercase().required().trim(),
        })
      )
      .required("Preencha pelo menos um CNPJ"),
  }),

});

export default FormAddUserValidationSchema;
